import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    background: '#F2F1F1',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rootForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    marginTop: '31vh',
    marginBottom: '3%',
    overflowX: 'hidden',
  },
  accordionRoot: {
    boxShadow: 'none',
    borderBottom: 'none',
    marginBottom: '12px',
  },
  summary: {
    backgroundColor: '#C4C4C4',
    borderRadius: '5px',
  },
  details: {
    backgroundColor: '#ECECEC',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
  },
  label: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '13px',
    fontWeight: 'bold',
    float: 'left',
    marginBottom: '7px',
    width: '97%',
  },
  medium: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '97%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  input: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '1%',
    fontSize: '16px',
    opacity: '100%',
    outline: 'none',
    borderRadius: '5px',
  },
  item: {},
  infoRow: {
    fontSize: '12px',
    color: '#555',
    marginTop: '4px',
  },
  switchLabel: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    cursor: 'pointer',
    marginBottom: '16px',
  },
  registerBtn: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '16px',
    paddingRight: '12px',
  },
  button: {
    background: '#026894',
    border: 'none',
    color: '#fff',
    height: '36px',
    padding: '0 20px',
    borderRadius: '2px',
    fontWeight: 'bold',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    '&:disabled': { background: '#9CB7C4', cursor: 'not-allowed' },
  },
}));

export default useStyles;
